var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"hero is-primary"},[(_vm.challenge)?_c('div',{staticClass:"container"},[_c('h1',{staticClass:"title is-2"},[_vm._v("Editer le challenge")]),_vm._v(" "),_c('challenge-form',{attrs:{"challenge":_vm.challenge}})],1):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-600d3ef5","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/PageChallengeEdit.vue
// module id = null
// module chunks = 